var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAuxData = function SvgIconAuxData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4.333 5.25v9.5C4.333 15.993 6.871 17 10 17s5.667-1.006 5.667-2.25v-9.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4.333 10c0 1.243 2.538 2.25 5.667 2.25s5.667-1.006 5.667-2.25M10 7.501c3.13 0 5.667-1.007 5.667-2.25S13.13 3 10 3 4.333 4.008 4.333 5.25c0 1.244 2.537 2.251 5.667 2.251"
  })));
};
export default SvgIconAuxData;